import * as React from "react";
import { cn } from "@lib/utils/ui";
function Card({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div data-slot="card" className={cn("bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm", className)} {...props} data-sentry-component="Card" data-sentry-source-file="card.tsx" />;
}
function CardHeader({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div data-slot="card-header" className={cn("@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6", className)} {...props} data-sentry-component="CardHeader" data-sentry-source-file="card.tsx" />;
}
function CardTitle({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div data-slot="card-title" className={cn("leading-none font-semibold", className)} {...props} data-sentry-component="CardTitle" data-sentry-source-file="card.tsx" />;
}
function CardDescription({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div data-slot="card-description" className={cn("text-muted-foreground text-sm", className)} {...props} data-sentry-component="CardDescription" data-sentry-source-file="card.tsx" />;
}
function CardAction({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div data-slot="card-action" className={cn("col-start-2 row-span-2 row-start-1 self-start justify-self-end", className)} {...props} data-sentry-component="CardAction" data-sentry-source-file="card.tsx" />;
}
function CardContent({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div data-slot="card-content" className={cn("px-6", className)} {...props} data-sentry-component="CardContent" data-sentry-source-file="card.tsx" />;
}
function CardFooter({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return <div data-slot="card-footer" className={cn("flex items-center px-6 [.border-t]:pt-6", className)} {...props} data-sentry-component="CardFooter" data-sentry-source-file="card.tsx" />;
}
export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent };